import { styled } from '@material-ui/core';

import { down } from '../../../assets/style/breakpointHelpers';
import { domTag } from '../styledFilter';

export const RadioGroupContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'left',
	alignItems: 'flex-start',
});

export const RadioGroupLabel = styled('label')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-label-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-text-primary)',
	marginBottom: 10,
});

export const RadioOptionsWrapper = styled(domTag('div', ['iserror', 'isvalid']))(({
	iserror,
	isvalid,
}: {
	iserror?: string;
	isvalid?: boolean;
}) => {
	const getBorderColor = () => {
		if (iserror) return 'var(--color-error)';
		if (isvalid) return 'var(--color-success)';
		return 'var(--color-border-default)';
	};

	return {
		'display': 'flex',
		'flexDirection': 'row',
		'gap': 0,
		'padding': 0,
		'borderRadius': 'var(--radius-default)',
		'border': `1px solid ${getBorderColor()}`,
		'backgroundColor': 'var(--color-bg-secondary)',
		'overflow': 'hidden',
		'height': 40,
		'transition': 'border-color var(--transition-fast), box-shadow var(--transition-fast)',
		[down('md')]: {
			height: 48,
		},
		'&:focus-within': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-focus)',
			boxShadow: iserror
				? '0 0 0 3px var(--color-error-bg)'
				: isvalid
					? '0 0 0 3px color-mix(in srgb, var(--color-success) 20%, transparent)'
					: '0 0 0 3px color-mix(in srgb, var(--color-brand-primary) 20%, transparent)',
		},
	};
});

export const RadioOption = styled('label')({
	'display': 'flex',
	'flex': 1,
	'alignItems': 'center',
	'justifyContent': 'center',
	'gap': 0,
	'padding': '0 16px',
	'cursor': 'pointer',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-body-size)',
	'color': 'var(--color-text-secondary)',
	'backgroundColor': 'transparent',
	'transition': 'all var(--transition-fast)',
	'borderRight': '1px solid var(--color-border-default)',
	'height': '100%',
	'position': 'relative',

	'&:last-child': {
		borderRight: 'none',
	},

	'&:hover': {
		backgroundColor: 'var(--color-bg-tertiary)',
		color: 'var(--color-text-primary)',
	},

	'&:has(input:checked)': {
		backgroundColor: 'var(--color-brand-primary)',
		color: '#fff',
	},
});

export const RadioInput = styled('input')({
	position: 'absolute',
	opacity: 0,
	width: 0,
	height: 0,
	margin: 0,
	padding: 0,
});
